/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ slug: NonNullable<unknown> }} Error_Shop_Target_Category_MissingInputs */

const vi_error_shop_target_category_missing = /** @type {(inputs: Error_Shop_Target_Category_MissingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Danh mục "${i?.slug}" không còn tồn tại — chọn danh mục khác cho liên kết.`)
};

/**

* @param {Error_Shop_Target_Category_MissingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_shop_target_category_missing = /** @type {((inputs: Error_Shop_Target_Category_MissingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Shop_Target_Category_MissingInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_shop_target_category_missing(inputs)
});